import { CheckBoxOutlineBlank } from "@mui/icons-material";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import React, { useEffect, useState } from "react";
import CommentOutlinedIcon from "@mui/icons-material/CommentOutlined";
const baseUrl = process.env.REACT_APP_SERVER_URL;
import noDataIcon from "../../assets/glass.svg";
import axios from "axios";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";

const DataGeneral = () => {
  const currentYear = new Date().getFullYear();
  const latestThreeYears = [
    currentYear,
    currentYear - 1,
    currentYear - 2,
    currentYear - 8,
  ];
  const [selectedYear, setSelectedYear] = useState(currentYear);
  const [selectedChapter, setSelectedChapter] = useState("all");
  const [selectedQuestionType, setSelectedQuestionType] = useState("all");
  const [myMappedData, setMyMappedData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [requiredQuestionsChecked, setRequiredQuestionsChecked] =
    useState(false);
  const [commentModalOpen, setCommentModalOpen] = useState(false);
  const [selectedQuestion, setSelectedQuestion] = useState(null);

  useEffect(() => {
    fetchData(selectedYear);
  }, [selectedYear]);

  const fetchData = async (year) => {
    setLoading(true);
    if (!year || year.length === 0) {
      console.warn("No years provided.");
      return;
    }

    const token = localStorage.getItem("auth_token");
    if (!token) {
      console.error("No authentication token found!");
      return;
    }

    const url = `${baseUrl}/api/principal/reports/data_general?year=${year}`;

    try {
      const response = await axios.get(url, {
        headers: {
          Authorization: `token ${token}`,
        },
      });

      const apiData = response.data.data;
      const transformedData = transformApiData(apiData, selectedYear);
      setLoading(false);
      setMyMappedData(transformedData);
    } catch (error) {
      console.error("Error fetching data:", error);
      setLoading(false);
    }
  };

  const toggleRequiredQuestionsCheck = () => {
    setRequiredQuestionsChecked(!requiredQuestionsChecked);
  };

  const transformApiData = (apiData, selectedYear) => {
    if (!Array.isArray(apiData)) return [];

    return apiData.map((section) => {
      const result = section.results?.[selectedYear];
      const questions = result?.questions || [];
      return {
        id: section.id,
        title: section.title,
        icon: (
          <img
            src={section.icon}
            alt="section icon"
            style={{ width: 32, height: 32, objectFit: "contain" }}
          />
        ),
        questions: questions.map((q) => ({
          id: q.id,
          questionText: q.question,
          type: q.question_type_human || q.question_type,
          required: q.obligatory ? "Sí" : "No",
          obligatory: q.obligatory,
          completed: q.is_answered,
          comment: q?.answer?.comment,
        })),
      };
    });
  };

  const getFilteredData = () => {
    let filtered = [...myMappedData];

    // Filter by chapter
    if (selectedChapter !== "all") {
      filtered = filtered.filter(
        (section) => section.id.toString() === selectedChapter
      );
    }

    // Filter by obligatory questions
    if (requiredQuestionsChecked) {
      filtered = filtered.map((section) => ({
        ...section,
        questions: section.questions.filter((q) => q.obligatory),
      }));
    }

    // Filter by question type
    if (selectedQuestionType !== "all") {
      filtered = filtered.map((section) => ({
        ...section,
        questions: section.questions.filter(
          (q) => q.type === selectedQuestionType
        ),
      }));
    }

    return filtered;
  };

  // Get unique question types for filter options
  const questionTypes = Array.from(
    new Set(
      myMappedData.flatMap((section) => section.questions.map((q) => q.type))
    )
  ).filter(Boolean);
  return (
    <>
      <Dialog
        open={commentModalOpen}
        onClose={() => setCommentModalOpen(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>Comentario</DialogTitle>
        <DialogContent dividers>
          <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
            Pregunta:
          </Typography>
          <Typography variant="body1" paragraph>
            {selectedQuestion?.name}
          </Typography>

          <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
            Comentario:
          </Typography>
          <Typography variant="body2" style={{ whiteSpace: "pre-wrap" }}>
            {selectedQuestion?.comment}
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setCommentModalOpen(false)} color="primary">
            Cerrar
          </Button>
        </DialogActions>
      </Dialog>
      <div style={{ fontFamily: "Arial, sans-serif" }}>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "10px",
            marginBottom: "15px",
            borderBottom: "1px solid grey",
          }}
        >
          <div
            style={{
              padding: "20px",
              display: "flex",
              justifyContent: "space-between",
              flexDirection: "column",
              width: "100%",
            }}
          >
            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
              <strong style={{ whiteSpace: "nowrap" }}>Filtrar por:</strong>
              <select
                style={selectStyle}
                value={selectedYear}
                onChange={(e) => setSelectedYear(Number(e.target.value))}
              >
                {latestThreeYears?.map((year) => (
                  <option key={year} value={year}>
                    Año: {year}
                  </option>
                ))}
              </select>
              <select
                style={{
                  ...selectStyle,
                  appearance: "none",
                  WebkitAppearance: "none",
                  MozAppearance: "none",
                  width: "20%",
                }}
                value={selectedChapter}
                onChange={(e) => setSelectedChapter(e.target.value)}
              >
                <option value="all">Principios</option>
                {myMappedData.map((section) => (
                  <option
                    key={section.id}
                    value={section.id}
                    style={{
                      whiteSpace: "normal", // Allows text to wrap if needed
                    }}
                  >
                    {section.title}
                  </option>
                ))}
              </select>
              <select
                style={selectStyle}
                value={selectedQuestionType}
                onChange={(e) => setSelectedQuestionType(e.target.value)}
              >
                <option value="all">Todos los tipos </option>
                {questionTypes.map((type) => (
                  <option key={type} value={type}>
                    {type}
                  </option>
                ))}
              </select>
            </div>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "5px",
                cursor: "pointer",
              }}
              onClick={toggleRequiredQuestionsCheck}
            >
              {requiredQuestionsChecked ? (
                <CheckBoxIcon style={{ color: "#1E80B0" }} />
              ) : (
                <CheckBoxOutlineBlank style={{ color: "#1E80B0" }} />
              )}
              <label htmlFor="ver-obligatorias" style={{ cursor: "pointer" }}>
                Ver preguntas obligatorias
              </label>
            </div>
          </div>
        </div>

        {/* Report Data */}
        {loading ? (
          <div style={{ textAlign: "center", padding: "20px" }}>
            <p>Cargando datos...</p>
          </div>
        ) : myMappedData?.length === 0 ? (
          <div
            style={{
              textAlign: "center",
              padding: "40px",
              color: "#888",
              marginTop: "13%",
            }}
          >
            <span
              style={{
                fontSize: "48px",
                display: "inline-block",
                marginBottom: "16px",
              }}
            >
              <img
                src={noDataIcon}
                alt="no-data"
                style={{ objectFit: "cover" }}
              />
            </span>
            <p style={{ fontSize: "16px", lineHeight: 1.5 }}>
              Los resultados de este año se verán reflejados
              <br />
              una vez sean revisados por la firma auditora de marca.
            </p>
          </div>
        ) : (
          getFilteredData().map((section, index) => (
            <div
              key={index}
              style={{
                borderBottom: "1px solid #ddd",
                padding: "10px 0",
                display: "flex",
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                  width: "20%",
                }}
              >
                <span>{section.icon}</span>{" "}
                <div style={{ fontWeight: "bold", fontSize: "large" }}>
                  {section.title}
                </div>
              </div>
              <div style={{ width: "80%" }}>
                <table
                  style={{
                    width: "100%",
                    borderCollapse: "collapse",
                    marginTop: "10px",
                  }}
                >
                  <thead>
                    <tr>
                      <th style={{ padding: "8px", textAlign: "left" }}>
                        Pregunta
                      </th>
                      <th style={{ padding: "8px", textAlign: "left" }}>
                        Tipo pregunta
                      </th>
                      <th style={{ padding: "8px", textAlign: "left" }}>
                        Obligatorio
                      </th>
                      <th style={{ padding: "8px", textAlign: "left" }}>
                        Completo
                      </th>
                      <th style={{ padding: "8px", textAlign: "left" }}></th>
                    </tr>
                  </thead>
                  <tbody>
                    {section.questions.length ? (
                      section.questions.map((q, qIndex) => (
                        <tr
                          key={qIndex}
                          style={{ borderBottom: "1px solid #ddd" }}
                        >
                          <td style={{ padding: "8px" }}>{qIndex + 1}</td>
                          <td style={{ padding: "8px" }}>{q.type}</td>
                          <td style={{ padding: "8px" }}>{q.required}</td>
                          <td style={{ padding: "8px" }}>
                            {q.completed ? (
                              <CheckBoxIcon style={{ color: "#95C11F" }} />
                            ) : (
                              "⬜"
                            )}
                          </td>
                          <td style={{ padding: "8px" }}>
                            <CommentOutlinedIcon
                              style={{ cursor: "pointer" }}
                              onClick={() => {
                                setSelectedQuestion({
                                  name: q.questionText,
                                  comment: q.comment || "Sin comentarios",
                                  id: q.id || "Sin comentarios",
                                });
                                setCommentModalOpen(true);
                              }}
                            />
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td
                          colSpan={5}
                          style={{
                            textAlign: "center",
                            padding: "16px",
                            color: "#888",
                          }}
                        >
                          N/A
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          ))
        )}
      </div>
    </>
  );
};

const selectStyle = {
  padding: "10px",
  marginRight: "10px",
  border: "1px solid #ddd",
  borderRadius: "10px",
  backgroundColor: "#fff",
  fontSize: "medium",
};

export default DataGeneral;
